import api from 'api';
import { DesignTemplates } from 'records/DesignTemplate';

export const ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_START = 'ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_START';
export const ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_SUCCESS = 'ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_SUCCESS';
export const ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_ERROR = 'ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_ERROR';
export const ENLARGE_VIEW_TEMPLATES_RESET_STATE = 'DESIGN_TEMPLATES_RESET_STATE';

function enlargeViewDesignTemplatesAsyncActionStart() {
  return {
    type: ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_START,
  };
}

function enlargeViewDesignTemplatesAsyncActionError(error) {
  return {
    type: ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_ERROR,
    error,
  };
}

function enlargeViewDesignTemplatesAsyncActionSuccess(data) {
  return {
    type: ENLARGE_VIEW_TEMPLATES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetenlargeViewDesignTemplatesState() {
  return {
    type: ENLARGE_VIEW_TEMPLATES_RESET_STATE,
  };
}

export function getenlargeViewDesignTemplates(templateId) {
  return (dispatch, getState) => {
    dispatch(enlargeViewDesignTemplatesAsyncActionStart());
    return api.request(
      `design/designtemplates/typeitem?templateId=${ templateId }`,
      'get',
      null
    )
    .then((data) => {
      dispatch(enlargeViewDesignTemplatesAsyncActionSuccess(data));
      return new DesignTemplates(data);
    })
    .catch((err) => {
      dispatch(enlargeViewDesignTemplatesAsyncActionError('Unable to get templates'));
      throw (err);
    });
  };
}
